import { makeAutoObservable } from 'mobx'
import { PageLayoutStore } from 'shared/layout'
import { type IDropdownItem, Typography } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { uiStore } from 'shared/store/uiStore'
import { LINK_COMPLIANCE_TOLL_FREE_LEARN_MORE_LINK } from 'shared/constants/links'
import { type IResponseNumber } from 'entities/Phone/api/types'
import { CompliancePath } from 'pages/settings/pages/compliance/route/compliancePath'
import { TollFreeRoutesSteps } from 'pages/settings/pages/compliance/pages/tollFree/route/type'
import { LearnMoreLink } from 'pages/settings/ui/LearnMoreLink/LearnMoreLink'

export class SettingsStore {
  private _pageLayoutStore = new PageLayoutStore()
  private _tollFreePreAssignedNumber: IDropdownItem | null = null

  private _modalId = 'verify-number-modal'

  constructor() {
    makeAutoObservable(this)
  }

  get tollFreePreAssignedNumber() {
    return this._tollFreePreAssignedNumber
  }

  get pageLayoutStore() {
    return this._pageLayoutStore
  }

  setTollFreePreAssignedNumber = (number: IDropdownItem | null) => {
    this._tollFreePreAssignedNumber = number
  }

  openVerifyNumberModal = (number: IResponseNumber, assignedInboxName: string) => {
    const desc = (
      <>
        <Typography ariaLabel='toll-free-number-verification-desc'>
          Carriers require verification for toll-free numbers before they can be used. This ensures
          smooth delivery and avoids filtering.
        </Typography>
        <Typography ariaLabel='toll-free-number-verification-learn-more' tag='div'>
          <LearnMoreLink href={LINK_COMPLIANCE_TOLL_FREE_LEARN_MORE_LINK}>Learn more</LearnMoreLink>
        </Typography>
      </>
    )
    modalStore.addModal({
      id: this._modalId,
      width: 280,
      type: ModalTypeList.INFO,
      title: 'Let’s verify your toll-free number',
      desc,
      primaryAction: {
        text: 'Verify',
        onAction: () => {
          modalStore.closeModal(this._modalId)

          uiStore.changeRoute({
            path: `/${CompliancePath.compliance.tollFree.steps}/${TollFreeRoutesSteps.numbers}`,
          })

          this.setTollFreePreAssignedNumber({
            id: number.id,
            label: number.formattedNumber || '',
            data: {
              formatted_number: number.formattedNumber,
              numberable: {
                name: assignedInboxName,
              },
              number: number.number,
              national_number: number.national_number,
            },
          })
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => modalStore.closeModal(this._modalId),
      },
    })
  }
}
